import React from "react";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

export default function Communication({
  client,
  languageCodes,
  handleInputChange,
  FORM_MODE,
}) {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6} md={4}>
        <TextField
          name="TelephoneNumber"
          label="Telefonnummer"
          disabled={FORM_MODE === "LOCKED"}
          value={client?.TelephoneNumber}
          onChange={(e) => handleInputChange("TelephoneNumber", e.target.value)}
          size="small"
          fullWidth
          margin="dense"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <TextField
          name="MobileNumber"
          label="Mobiltelefonnr"
          disabled={FORM_MODE === "LOCKED"}
          value={client?.MobileNumber}
          onChange={(e) => handleInputChange("MobileNumber", e.target.value)}
          size="small"
          fullWidth
          margin="dense"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <TextField
          name="Email"
          label="E-post"
          disabled={FORM_MODE === "LOCKED"}
          value={client?.Email}
          onChange={(e) => handleInputChange("Email", e.target.value)}
          size="small"
          fullWidth
          margin="dense"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <TextField
          name="Website"
          label="Hemsida"
          disabled={FORM_MODE === "LOCKED"}
          value={client?.Website}
          onChange={(e) => handleInputChange("Website", e.target.value)}
          size="small"
          fullWidth
          margin="dense"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <TextField
          name="ContactPerson"
          label="Kontaktperson"
          disabled={FORM_MODE === "LOCKED"}
          value={client?.ContactPerson}
          onChange={(e) => handleInputChange("ContactPerson", e.target.value)}
          size="small"
          fullWidth
          margin="dense"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <TextField
          name="ContactPerson2"
          label="Kontaktperson2"
          disabled={FORM_MODE === "LOCKED"}
          value={client.ContactPerson2}
          onChange={(e) => handleInputChange("ContactPerson2", e.target.value)}
          size="small"
          fullWidth
          margin="dense"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <FormControl fullWidth sx={{ textAlign: "left" }} margin="dense">
          <InputLabel>Språkkod</InputLabel>
          <Select
            value={client.LanguageCode}
            onChange={(e) => handleInputChange("LanguageCode", e.target.value)}
            name="LanguageCode"
            label="Språkkod"
            disabled={FORM_MODE === "LOCKED"}
            size="small"
          >
            {languageCodes?.map((language) => (
              <MenuItem key={language.Value} value={language.Value}>
                {language.Name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
    </Grid>
  );
}
